import { cn } from "@/lib/utils";

/**
 * px-mark — l'incarnation de Pixel. Grille 2×2 de carrés, seul élément
 * vivant de l'interface (avatar de l'agent, loader universel, marque).
 * Les états animés sont définis dans index.css (.pxmark[data-state]).
 *
 * - idle       : 3 carrés encre + 1 éteint
 * - thinking   : extinction/allumage en séquence lente
 * - generating : un carré rose parcourt la grille
 * - success    : 4 pleins, flash unique
 * - error      : 1 carré rouge
 */
export type PxMarkState = "idle" | "thinking" | "generating" | "success" | "error";

interface PxMarkProps {
  /** Côté total en pixels (la grille entière). 16 en avatar chat, 24-32 en vue. */
  size?: number;
  state?: PxMarkState;
  className?: string;
  /** Libellé pour lecteurs d'écran ; le px-mark est décoratif par défaut. */
  label?: string;
}

export function PxMark({ size = 16, state = "idle", className, label }: PxMarkProps) {
  return (
    <span
      className={cn("pxmark shrink-0", className)}
      data-state={state}
      style={{ width: size, height: size }}
      role={label ? "img" : "presentation"}
      aria-label={label}
    >
      <i />
      <i />
      <i />
      <i />
    </span>
  );
}
